import React, { useState, useEffect } from "react";
import alertify from "alertifyjs";
import "./Dashboard.css";
import { db } from "../../App.js";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { getKelompok as getLevel } from "../../App";
import {
  getDocs,
  collection,
  query,
  where,
  doc,
  setDoc,
  deleteDoc,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import threeIcon from "../../Assets/three-dots.png";
import trash from "../../Assets/trash.png";
import trashWhite from "../../Assets/trash-white.png";
import edit from "../../Assets/edit.png";
import editWhite from "../../Assets/edit-white.png";

async function getUnlisted() {
  let tempo = [];
  const q = query(collection(db, "question"));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    if (doc.data().nomor === "") tempo.push(doc);
    else if (doc.data().level === "") tempo.push(doc);
  });

  return new Promise((resolve, reject) => {
    resolve(Promise.resolve(tempo));
  });
}

async function getPertanyaan(data) {
  let tempo = [];
  const q = query(collection(db, "question"), where("level", "==", data));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    if (doc.data().nomor === "") return;
    tempo.push(doc);
  });

  return new Promise((resolve, reject) => {
    resolve(Promise.resolve(tempo));
  });
}
let queue = [];
function Dashboard() {
  document.querySelector("body").style.background = "#F3F4F5";

  let [levelList, setLevelList] = useState([]);

  let [unlistedList, setUnlistedList] = useState([]);

  let [PertanyaanTambah, setPertanyaanTambah] = useState();
  let [OptionATambah, setOptionATambah] = useState();
  let [OptionBTambah, setOptionBTambah] = useState();
  let [OptionCTambah, setOptionCTambah] = useState();
  let [OptionDTambah, setOptionDTambah] = useState();
  let [NomorTambah, setNomorTambah] = useState("");
  let [LevelTambah, setLevelTambah] = useState("");
  let [JawabanTambah, setJawabanTambah] = useState("A");

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (!user) {
      window.location.href = "/login";
    }
  });

  //
  //
  // SECTION LIST LEVEL
  //
  //
  let currentStatusLevel;
  let currentSelectedLevel;
  let currentSelectedTrash;

  function LevelListDiv(arg) {
    let levelDatabase = arg.data;
    let levelData = arg.data.data();

    function hoverLevelImageIn() {
      let editElement = document.querySelector(
        `img.del-level-${levelData.level}`
      );
      editElement.src = trashWhite;
    }

    function hoverLevelImageOut() {
      let editElement = document.querySelector(
        `img.del-level-${levelData.level}`
      );

      if (currentSelectedLevel === levelData.level) return;
      editElement.src = trash;
    }

    function selectLevelButton() {
      let previousLevelElement = document.querySelector(
        `.level-item-wrap.level-${currentSelectedLevel}`
      );
      let levelElement = document.querySelector(
        `.level-item-wrap.level-${levelData.level}`
      );
      let pertanyaanElement = document.querySelector(
        `.pertanyaan-list-item-wrap.level-${levelData.level}`
      );
      let previousPertanyaanElement = document.querySelector(
        `.pertanyaan-list-item-wrap.level-${currentStatusLevel}`
      );
      let trashImage = document.querySelector(
        `img.del-level-${levelData.level}`
      );
      let previousTrashImage = document.querySelector(
        `img.del-level-${currentSelectedTrash}`
      );

      if (previousPertanyaanElement) {
        previousPertanyaanElement.classList.add("non-display");
      }
      currentStatusLevel = levelData.level;
      pertanyaanElement.classList.remove("non-display");

      if (previousLevelElement) {
        previousLevelElement.classList.remove("level-selected-class");
      }

      currentSelectedLevel = levelData.level;
      levelElement.classList.add("level-selected-class");

      if (previousTrashImage) {
        previousTrashImage.src = trash;
      }

      currentSelectedTrash = levelData.level;
      trashImage.src = trashWhite;
    }

    function deleteLevelButton() {
      queue.push({
        type: "deleteLevel",
        data: {
          level: levelData.level,
          id: levelDatabase.id,
        },
      });

      let filteredLevel = levelList.filter(
        (el) => el.data().level !== levelData.level
      );
      setLevelList(filteredLevel);
    }

    return (
      <div
        className={`level-item-wrap level-${levelData.level}`}
        onMouseEnter={hoverLevelImageIn}
        onMouseLeave={hoverLevelImageOut}
      >
        <div className="level-list-item" onClick={selectLevelButton}>
          <div className="level-list-item-title">
            <p>Level {levelData.level}</p>
          </div>
        </div>
        <div
          className={`delete-level del-level-${levelData.level}`}
          onClick={deleteLevelButton}
        >
          <img
            className={`del-level-${levelData.level}`}
            src={trash}
            alt="delete"
            width="25px"
          />
        </div>
      </div>
    );
  }

  //
  //
  // SECTION LIST PERTANYAAN
  //
  //

  function PertanyaanListDiv(arg) {
    let pertanyaanDatabase = arg.data;
    let pertanyaanData = arg.data.data();
    let currentStatusPertanyaan;
    let [pertanyaanList, setPertanyaanList] = useState([]);
    let [PertanyaanEdit, setPertanyaanEdit] = useState();
    let [OptionAEdit, setOptionAEdit] = useState();
    let [OptionBEdit, setOptionBEdit] = useState();
    let [OptionCEdit, setOptionCEdit] = useState();
    let [OptionDEdit, setOptionDEdit] = useState();
    let [NomorEdit, setNomorEdit] = useState();
    let [LevelEdit, setLevelEdit] = useState();
    let [JawabanEdit, setJawabanEdit] = useState();

    useEffect(() => {
      getPertanyaan(pertanyaanData.level).then((data) => {
        if (!data.length) return;
        data.forEach((el) => {
          setPertanyaanList((pertanyaanList) => [...pertanyaanList, el]);
        });
      });
    }, []);

    function hoverLevelEditImageIn() {
      let editElement = document.querySelector(
        `.dropdown-menu-pertanyaan-item-edit img`
      );
      editElement.src = editWhite;
    }

    function hoverLevelEditImageOut() {
      let editElement = document.querySelector(
        `.dropdown-menu-pertanyaan-item-edit img`
      );
      editElement.src = edit;
    }

    function hoverLevelDeleteImageIn() {
      let editElement = document.querySelector(
        `.dropdown-menu-pertanyaan-item-delete img`
      );
      editElement.src = trashWhite;
    }

    function hoverLevelDeleteImageOut() {
      let editElement = document.querySelector(
        `.dropdown-menu-pertanyaan-item-delete img`
      );
      editElement.src = trash;
    }

    return (
      <div
        className={`pertanyaan-list-item-wrap level-${pertanyaanData.level} non-display`}
      >
        {pertanyaanList
          .sort((a, b) => a.data().nomor - b.data().nomor)
          .map((dataIndividualPertaynaan) => {
            async function PertanyaanDeleteButtton() {
              let filteredPertanyaan = pertanyaanList.filter(
                (el) => el.id !== dataIndividualPertaynaan.id
              );

              setPertanyaanList(filteredPertanyaan);

              queue.push({
                type: "deletePertanyaan",
                data: {
                  id: dataIndividualPertaynaan.id,
                },
              });
            }
            function CloseEditPertanyaanOverlay() {
              let editPertanyaanOverlay = document.querySelector(
                `.edit-pertanyaan-overlay.id-${dataIndividualPertaynaan.id}`
              );
              editPertanyaanOverlay.classList.toggle("non-display");
            }

            function dropdownMenuPertanyaan() {
              let dropdownPertanyaan = document.querySelector(`
            .dropdown-menu-pertanyaan.id-${dataIndividualPertaynaan.id}`);

              let previousDropdownPertanyaan = document.querySelector(`
            .dropdown-menu-pertanyaan.id-${currentStatusPertanyaan}`);

              if (previousDropdownPertanyaan) {
                previousDropdownPertanyaan.classList.add("non-display");
              }

              dropdownPertanyaan.classList.toggle("non-display");
              currentStatusPertanyaan = pertanyaanDatabase.id;
            }

            function PertanyaanEditButton() {
              let editOverlayPertanyaan = document.querySelector(`
            .edit-pertanyaan-overlay.id-${dataIndividualPertaynaan.id}`);

              let dataIndividualPertaynaanData =
                dataIndividualPertaynaan.data();

              editOverlayPertanyaan.classList.toggle("non-display");
              setPertanyaanEdit(dataIndividualPertaynaanData.Question);
              setLevelEdit(dataIndividualPertaynaanData.level);
              setOptionAEdit(dataIndividualPertaynaanData.Option[0].answer);
              setOptionBEdit(dataIndividualPertaynaanData.Option[1].answer);
              setOptionCEdit(dataIndividualPertaynaanData.Option[2].answer);
              setOptionDEdit(dataIndividualPertaynaanData.Option[3].answer);
              setJawabanEdit(dataIndividualPertaynaanData.Correct);
              setNomorEdit(dataIndividualPertaynaanData.nomor);

              let dropdownPertanyaan = document.querySelector(`
            .dropdown-menu-pertanyaan.id-${dataIndividualPertaynaan.id}`);

              let previousDropdownPertanyaan = document.querySelector(`
            .dropdown-menu-pertanyaan.id-${currentStatusPertanyaan}`);

              if (previousDropdownPertanyaan) {
                previousDropdownPertanyaan.classList.add("non-display");
              }

              dropdownPertanyaan.classList.toggle("non-display");
              currentStatusPertanyaan = pertanyaanDatabase.id;
            }

            async function TransferToUnlisted() {
              await setDoc(doc(db, "question", dataIndividualPertaynaan.id), {
                Question: PertanyaanEdit,
                Option: [
                  {
                    answer: OptionAEdit,
                    option: "A",
                  },
                  {
                    answer: OptionBEdit,
                    option: "B",
                  },
                  {
                    answer: OptionCEdit,
                    option: "C",
                  },
                  {
                    answer: OptionDEdit,
                    option: "D",
                  },
                ],
                Correct: JawabanEdit,
                level: LevelEdit,
                nomor: NomorEdit,
              });

              setUnlistedList((el) => [
                ...el,
                {
                  id: dataIndividualPertaynaan.id,
                  data: function () {
                    return {
                      Question: PertanyaanEdit,
                      Option: [
                        {
                          answer: OptionAEdit,
                          option: "A",
                        },
                        {
                          answer: OptionBEdit,
                          option: "B",
                        },
                        {
                          answer: OptionCEdit,
                          option: "C",
                        },
                        {
                          answer: OptionDEdit,
                          option: "D",
                        },
                      ],
                      Correct: JawabanEdit,
                      level: LevelEdit,
                      nomor: NomorEdit,
                    };
                  },
                },
              ]);
            }

            async function editPertanyaanFunction() {
              await setDoc(doc(db, "question", dataIndividualPertaynaan.id), {
                Question: PertanyaanEdit,
                Option: [
                  {
                    answer: OptionAEdit,
                    option: "A",
                  },
                  {
                    answer: OptionBEdit,
                    option: "B",
                  },
                  {
                    answer: OptionCEdit,
                    option: "C",
                  },
                  {
                    answer: OptionDEdit,
                    option: "D",
                  },
                ],
                Correct: JawabanEdit,
                level: LevelEdit,
                nomor: NomorEdit,
              });

              setPertanyaanList((el) => [
                ...el,
                {
                  id: dataIndividualPertaynaan.id,
                  data: function () {
                    return {
                      Question: PertanyaanEdit,
                      Option: [
                        {
                          answer: OptionAEdit,
                          option: "A",
                        },
                        {
                          answer: OptionBEdit,
                          option: "B",
                        },
                        {
                          answer: OptionCEdit,
                          option: "C",
                        },
                        {
                          answer: OptionDEdit,
                          option: "D",
                        },
                      ],
                      Correct: JawabanEdit,
                      level: LevelEdit,
                      nomor: NomorEdit,
                    };
                  },
                },
              ]);
            }

            function EditPertanyaanSaveButton(e) {
              e.preventDefault();

              if (!PertanyaanEdit) return;
              if (!OptionAEdit) return;
              if (!OptionBEdit) return;
              if (!OptionCEdit) return;
              if (!OptionDEdit) return;
              if (!JawabanEdit) return;

              if (!NomorEdit || !LevelEdit) {
                TransferToUnlisted();
              } else {
                editPertanyaanFunction();
              }
            }
            // if (!dataIndividualPertaynaan.data().nomor) {
            //   return;
            // }

            return (
              <div className="pertanyaan-list-item">
                <div className="pertanyaan-list-item-title">
                  <p>
                    {dataIndividualPertaynaan.data().nomor}.
                    {dataIndividualPertaynaan.data().Question}
                  </p>
                </div>

                <div
                  className={`three-dot id-${dataIndividualPertaynaan.id}`}
                  onClick={dropdownMenuPertanyaan}
                >
                  <img src={threeIcon} alt="three-dot" width="25px" />
                </div>

                <div
                  className={`dropdown-menu-pertanyaan id-${dataIndividualPertaynaan.id} non-display`}
                >
                  <div className="dropdown-menu-pertanyaan-item">
                    <div
                      className="dropdown-menu-pertanyaan-item-edit"
                      onClick={PertanyaanEditButton}
                      onMouseEnter={hoverLevelEditImageIn}
                      onMouseLeave={hoverLevelEditImageOut}
                    >
                      <img src={edit} alt="edit" width="25px" />
                      <span>Edit</span>
                    </div>

                    <div
                      className="dropdown-menu-pertanyaan-item-delete"
                      onClick={PertanyaanDeleteButtton}
                      onMouseEnter={hoverLevelDeleteImageIn}
                      onMouseLeave={hoverLevelDeleteImageOut}
                    >
                      <img src={trash} alt="delete" width="25px" />
                      <span>Delete</span>
                    </div>
                  </div>
                </div>

                <div
                  className={`edit-pertanyaan-overlay id-${dataIndividualPertaynaan.id} non-display`}
                >
                  <div className="edit-pertanyaan-overlay-content">
                    <div
                      className="edit-pertanyaan-close"
                      onClick={CloseEditPertanyaanOverlay}
                    ></div>
                    <div className="edit-pertanyaan-overlay-content-title">
                      <h1>Edit Pertanyaan</h1>
                    </div>

                    <form className="edit-pertanyaan-form">
                      <div className="edit-pertanyaan-form-item">
                        <div className="edit-pertanyaan-form-item-pertanyaan">
                          <label>Pertanyaan</label>
                          <input
                            type="text"
                            name="pertanyaan"
                            value={PertanyaanEdit}
                            onChange={(e) => {
                              setPertanyaanEdit(e.target.value);
                            }}
                          />
                        </div>

                        <div className="edit-pertanyaan-form-item-jawabanA">
                          <label>Jawaban A</label>
                          <input
                            type="text"
                            name="jawaban"
                            value={OptionAEdit}
                            onChange={(e) => {
                              setOptionAEdit(e.target.value);
                            }}
                          />
                        </div>

                        <div className="edit-pertanyaan-form-item-jawabanB">
                          <label>Jawaban B</label>
                          <input
                            type="text"
                            name="jawaban"
                            value={OptionBEdit}
                            onChange={(e) => {
                              setOptionBEdit(e.target.value);
                            }}
                          />
                        </div>

                        <div className="edit-pertanyaan-form-item-jawabanC">
                          <label>Jawaban C</label>
                          <input
                            type="text"
                            name="jawaban"
                            value={OptionCEdit}
                            onChange={(e) => {
                              setOptionCEdit(e.target.value);
                            }}
                          />
                        </div>

                        <div className="edit-pertanyaan-form-item-jawabanD">
                          <label>Jawaban D</label>
                          <input
                            type="text"
                            name="jawaban"
                            value={OptionDEdit}
                            onChange={(e) => {
                              setOptionDEdit(e.target.value);
                            }}
                          />
                        </div>

                        <div className="edit-pertanyaan-form-item-jawabanBenar">
                          <label>Jawaban Benar</label>
                          <select
                            name="jawaban"
                            value={JawabanEdit}
                            onChange={(e) => {
                              setJawabanEdit(e.target.value);
                            }}
                          >
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                            <option value="D">D</option>
                          </select>
                        </div>

                        <div className="edit-pertanyaan-form-item-level">
                          <label>Level</label>
                          <input
                            type="number"
                            name="level"
                            value={LevelEdit}
                            onChange={(e) => {
                              setLevelEdit(e.target.value);
                            }}
                          />
                        </div>

                        <div className="edit-pertanyaan-form-item-nomor">
                          <label>Nomor</label>
                          <input
                            type="number"
                            name="nomor"
                            value={NomorEdit}
                            onChange={(e) => {
                              setNomorEdit(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </form>

                    <div className="edit-pertanyaan-overlay-content-btn">
                      <div
                        className="edit-pertanyaan-overlay-content-btn-save"
                        onClick={EditPertanyaanSaveButton}
                      >
                        Save Changes
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  }

  //
  //
  // SECTION LIST UNLISTED
  //
  //

  // let [currentUnlistedIDEdit, setCurrentUnlistedIDEdit] = useState();

  function UnlistedListDiv(arg) {
    let unlistedDatabase = arg.data;
    let unlistedData = arg.data.data();
    let currentStatusUnlisted;
    let [PertanyaanEditUnlisted, setPertanyaanEditUnlisted] = useState();
    let [OptionAEditUnlisted, setOptionAEditUnlisted] = useState();
    let [OptionBEditUnlisted, setOptionBEditUnlisted] = useState();
    let [OptionCEditUnlisted, setOptionCEditUnlisted] = useState();
    let [OptionDEditUnlisted, setOptionDEditUnlisted] = useState();
    let [NomorEditUnlisted, setNomorEditUnlisted] = useState("");
    let [LevelEditUnlisted, setLevelEditUnlisted] = useState("");
    let [JawabanEditUnlisted, setJawabanEditUnlisted] = useState();

    function dropdownMenuUnlisted() {
      let dropdownPertanyaan = document.querySelector(`
      .dropdown-menu-unlisted.id-${unlistedDatabase.id}`);

      let previousDropdownPertanyaan = document.querySelector(`
      .dropdown-menu-unlisted.id-${currentStatusUnlisted}`);

      if (unlistedDatabase.id === currentStatusUnlisted) {
        dropdownPertanyaan.classList.toggle("non-display");
        currentStatusUnlisted = unlistedDatabase.id;
        return;
      }

      if (previousDropdownPertanyaan) {
        previousDropdownPertanyaan.classList.add("non-display");
      }

      dropdownPertanyaan.classList.toggle("non-display");
      currentStatusUnlisted = unlistedDatabase.id;
    }

    function DropdownUnlistedEditButton() {
      let editOverlayUnlisted = document.querySelector(
        `.edit-unlisted-overlay.id-${unlistedDatabase.id}`
      );
      editOverlayUnlisted.classList.toggle("non-display");
      setPertanyaanEditUnlisted(unlistedData.Question);
      setOptionAEditUnlisted(unlistedData.Option[0].answer);
      setOptionBEditUnlisted(unlistedData.Option[1].answer);
      setOptionCEditUnlisted(unlistedData.Option[2].answer);
      setOptionDEditUnlisted(unlistedData.Option[3].answer);
      setNomorEditUnlisted(unlistedData.nomor);
      setJawabanEditUnlisted(unlistedData.Correct);
      // setCurrentUnlistedIDEdit(unlistedDatabase.id);

      let dropdownPertanyaan = document.querySelector(`
      .dropdown-menu-unlisted.id-${unlistedDatabase.id}`);

      let previousDropdownPertanyaan = document.querySelector(`
      .dropdown-menu-unlisted.id-${currentStatusUnlisted}`);

      if (unlistedDatabase.id === currentStatusUnlisted) {
        dropdownPertanyaan.classList.toggle("non-display");
        currentStatusUnlisted = unlistedDatabase.id;
        return;
      }

      if (previousDropdownPertanyaan) {
        previousDropdownPertanyaan.classList.add("non-display");
      }

      dropdownPertanyaan.classList.toggle("non-display");
      currentStatusUnlisted = unlistedDatabase.id;
    }

    function DropdownUnlistedDeleteButton() {
      queue.push({
        type: "deletePertanyaan",
        data: {
          id: unlistedDatabase.id,
        },
      });

      let filteredUnlisted = unlistedList.filter(
        (unlisted) => unlisted.id !== unlistedDatabase.id
      );

      setUnlistedList(filteredUnlisted);
    }

    function hoverLevelEditImageIn() {
      let editElement = document.querySelector(
        `.dropdown-menu-unlisted-item-edit.id-${unlistedDatabase.id} img`
      );
      editElement.src = editWhite;
    }

    function hoverLevelEditImageOut() {
      let editElement = document.querySelector(
        `.dropdown-menu-unlisted-item-edit.id-${unlistedDatabase.id} img`
      );
      editElement.src = edit;
    }

    function hoverLevelDeleteImageIn() {
      let editElement = document.querySelector(
        `.dropdown-menu-unlisted-item-delete.id-${unlistedDatabase.id} img`
      );
      editElement.src = trashWhite;
    }

    function hoverLevelDeleteImageOut() {
      let editElement = document.querySelector(
        `.dropdown-menu-unlisted-item-delete.id-${unlistedDatabase.id} img`
      );
      editElement.src = trash;
    }

    function CloseEditUnlistedOverlay() {
      let editOverlayUnlisted = document.querySelector(
        `.edit-unlisted-overlay.id-${unlistedDatabase.id}`
      );

      editOverlayUnlisted.classList.toggle("non-display");
    }

    async function EditUnlistedSaveButton() {
      await setDoc(doc(db, "question", unlistedDatabase.id), {
        Question: PertanyaanEditUnlisted,
        Option: [
          {
            answer: OptionAEditUnlisted,
            option: "A",
          },
          {
            answer: OptionBEditUnlisted,
            option: "B",
          },
          {
            answer: OptionCEditUnlisted,
            option: "C",
          },
          {
            answer: OptionDEditUnlisted,
            option: "D",
          },
        ],
        nomor: NomorEditUnlisted,
        level: LevelEditUnlisted,
        Correct: JawabanEditUnlisted || unlistedData.Correct,
      });

      if (LevelEditUnlisted !== "" && NomorEditUnlisted !== "") {
        let filteredUnlisted = unlistedList.filter(
          (unlisted) => unlisted.id !== unlistedDatabase.id
        );
        setUnlistedList(filteredUnlisted);
      }
    }

    return (
      <div className={`unlisted-list-item-wrap id-${unlistedDatabase.id}`}>
        <div className="unlisted-list-item">
          <div className="unlisted-list-item-title">
            <p>{unlistedData.Question}</p>
          </div>
        </div>

        <div
          className={`three-dot id-${unlistedDatabase.id}`}
          onClick={dropdownMenuUnlisted}
        >
          <img src={threeIcon} alt="three-dot" width="25px" />
        </div>

        <div
          className={`dropdown-menu-unlisted id-${unlistedDatabase.id} non-display`}
        >
          <div
            className={`dropdown-menu-unlisted-item id-${unlistedDatabase.id}`}
          >
            <div
              className={`dropdown-menu-unlisted-item-edit id-${unlistedDatabase.id}`}
              onClick={DropdownUnlistedEditButton}
              onMouseOver={hoverLevelEditImageIn}
              onMouseLeave={hoverLevelEditImageOut}
            >
              <img src={edit} alt="edit" width="25px" />
              <span>Edit</span>
            </div>

            <div
              className={`dropdown-menu-unlisted-item-delete id-${unlistedDatabase.id}`}
              onClick={DropdownUnlistedDeleteButton}
              onMouseEnter={hoverLevelDeleteImageIn}
              onMouseLeave={hoverLevelDeleteImageOut}
            >
              <img src={trash} alt="delete" width="25px" />
              <span>Delete</span>
            </div>
          </div>
        </div>

        <div
          className={`edit-unlisted-overlay id-${unlistedDatabase.id} non-display`}
        >
          <div className="edit-unlisted-overlay-content">
            <div
              className="edit-unlisted-close"
              onClick={CloseEditUnlistedOverlay}
            ></div>
            <div className="edit-unlisted-overlay-content-title">
              <h1>Edit Pertanyaan</h1>
            </div>

            <form className="edit-unlisted-form">
              <div className="edit-unlisted-form-item">
                <div className="edit-unlisted-form-item-pertanyaan">
                  <label>Pertanyaan</label>
                  <input
                    type="text"
                    name="pertanyaan"
                    value={PertanyaanEditUnlisted}
                    onChange={(e) => {
                      setPertanyaanEditUnlisted(e.target.value);
                    }}
                  />
                </div>

                <div className="edit-unlisted-form-item-jawabanA">
                  <label>Jawaban A</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionAEditUnlisted}
                    onChange={(e) => {
                      setOptionAEditUnlisted(e.target.value);
                    }}
                  />
                </div>

                <div className="edit-unlisted-form-item-jawabanB">
                  <label>Jawaban B</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionBEditUnlisted}
                    onChange={(e) => {
                      setOptionBEditUnlisted(e.target.value);
                    }}
                  />
                </div>

                <div className="edit-unlisted-form-item-jawabanC">
                  <label>Jawaban C</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionCEditUnlisted}
                    onChange={(e) => {
                      setOptionCEditUnlisted(e.target.value);
                    }}
                  />
                </div>

                <div className="edit-unlisted-form-item-jawabanD">
                  <label>Jawaban D</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionDEditUnlisted}
                    onChange={(e) => {
                      setOptionDEditUnlisted(e.target.value);
                    }}
                  />
                </div>

                <div className="edit-unlisted-form-item-jawabanBenar">
                  <label>Jawaban Benar</label>
                  <select
                    name="jawaban"
                    value={JawabanEditUnlisted}
                    onChange={(e) => {
                      setJawabanEditUnlisted(e.target.value);
                    }}
                  >
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                    <option value="D">D</option>
                  </select>
                </div>

                <div className="edit-unlisted-form-item-level">
                  <label>Level</label>
                  <input
                    type="number"
                    name="level"
                    value={LevelEditUnlisted}
                    onChange={(e) => {
                      setLevelEditUnlisted(e.target.value);
                    }}
                  />
                </div>

                <div className="edit-unlisted-form-item-nomor">
                  <label>Nomor</label>
                  <input
                    type="number"
                    name="nomor"
                    value={NomorEditUnlisted}
                    onChange={(e) => {
                      setNomorEditUnlisted(e.target.value);
                    }}
                  />
                </div>
              </div>
            </form>

            <div className="edit-unliosted-overlay-content-btn">
              <div
                className="edit-unlisted-overlay-content-btn-save"
                onClick={EditUnlistedSaveButton}
              >
                Save Changes
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  //
  //
  //
  //
  //

  async function addPertanyaan(element) {
    await setDoc(doc(db, "question", element.data.id), {
      Question: element.data.Question,
      Option: [
        {
          answer: element.data.Option[0].answer,
          option: "A",
        },
        {
          answer: element.data.Option[1].answer,
          option: "B",
        },
        {
          answer: element.data.Option[2].answer,
          option: "C",
        },
        {
          answer: element.data.Option[3].answer,
          option: "D",
        },
      ],
      Correct: element.data.Correct,
      level: element.data.level,
      nomor: element.data.nomor,
    });
  }

  function TambahLevelButton() {
    let newLevelID = uuidv4();

    queue.push({
      type: "addLevel",
      data: {
        level: (levelList.length + 1).toString(),
        id: newLevelID,
      },
    });

    setLevelList((levelList) => [
      ...levelList,
      {
        id: newLevelID,
        data: function () {
          return {
            level: levelList.length + 1,
          };
        },
      },
    ]);
  }

  async function addLevel(element) {
    await setDoc(doc(db, "level", element.data.id), {
      level: element.data.level,
    });
  }

  async function deleteLevel(element) {
    await deleteDoc(doc(db, "level", element.data.id));
  }

  async function deletePerentanyaan(element) {
    await deleteDoc(doc(db, "question", element.data.id));
  }

  function TambahPertanyaanButton() {
    let tambahPertanyaanOverlay = document.querySelector(
      ".tambah-pertanyaan-overlay"
    );
    tambahPertanyaanOverlay.classList.toggle("non-display");
  }

  function CloseTambahPertanyaanOverlay() {
    let tambahPertanyaanOverlay = document.querySelector(
      ".tambah-pertanyaan-overlay"
    );
    tambahPertanyaanOverlay.classList.toggle("non-display");
  }

  async function addToUnlisted() {
    let newUnlistedID = uuidv4();

    await setDoc(doc(db, "question", newUnlistedID), {
      Question: PertanyaanTambah,
      Option: [
        {
          answer: OptionATambah,
          option: "A",
        },
        {
          answer: OptionBTambah,
          option: "B",
        },
        {
          answer: OptionCTambah,
          option: "C",
        },
        {
          answer: OptionDTambah,
          option: "D",
        },
      ],
      Correct: JawabanTambah,
      level: LevelTambah,
      nomor: NomorTambah,
    });

    getUnlisted().then((data) => {
      setUnlistedList(data);
    });
  }

  function tambahPertanyaanFunction() {
    let newUnlistedID = uuidv4();

    queue.push({
      type: "addPertanyaan",
      data: {
        id: newUnlistedID,
        Question: PertanyaanTambah,
        Option: [
          {
            answer: OptionATambah,
            option: "A",
          },
          {
            answer: OptionBTambah,
            option: "B",
          },
          {
            answer: OptionCTambah,
            option: "C",
          },
          {
            answer: OptionDTambah,
            option: "D",
          },
        ],
        Correct: JawabanTambah,
        level: LevelTambah,
        nomor: NomorTambah,
      },
    });

    setLevelList(levelList);
  }

  function TambahPertanyaanSaveButton(e) {
    e.preventDefault();

    if (!PertanyaanTambah) return;
    if (!OptionATambah) return;
    if (!OptionBTambah) return;
    if (!OptionCTambah) return;
    if (!OptionDTambah) return;
    if (!JawabanTambah) return;

    setPertanyaanTambah("");
    setOptionATambah("");
    setOptionBTambah("");
    setOptionCTambah("");
    setOptionDTambah("");
    setJawabanTambah("");
    setLevelTambah("");
    setNomorTambah("");

    if (!NomorTambah || !LevelTambah) {
      addToUnlisted();
    } else {
      tambahPertanyaanFunction();
    }
  }

  function SaveChangesButton(e) {
    e.preventDefault();

    let q = queue;

    q.forEach(async (element) => {
      if (element.type === "addLevel") {
        addLevel(element);
      }

      if (element.type === "deleteLevel") {
        deleteLevel(element);
      }

      if (element.type === "deletePertanyaan") {
        deletePerentanyaan(element);
      }

      if (element.type === "addPertanyaan") {
        addPertanyaan(element);
      }
    });

    alertify.success("Changes saved");
  }

  useEffect(() => {
    getLevel().then((data) => {
      data.forEach((el) => {
        setLevelList((levelList) => [...levelList, el]);
      });
    });

    getUnlisted().then((data) => {
      setUnlistedList(data);
    });
  }, []);

  return (
    <div className="dashboard">
      <div className="btns-wrap">
        <div className="btn-add-level" onClick={TambahLevelButton}>
          Tambah Level
        </div>

        <div className="btn-add-pertanyaan" onClick={TambahPertanyaanButton}>
          Tambah Pertanyaan
        </div>

        <div className="btn-save-changes" onClick={SaveChangesButton}>
          Save Changes
        </div>
      </div>

      <div className="dashboard-menu">
        <div className="level-list">
          {levelList
            .sort((a, b) => a.data().level - b.data().level)
            .map((data) => {
              return <LevelListDiv data={data}></LevelListDiv>;
            })}
        </div>

        <div className="pertanyaan-list">
          {levelList
            .sort((a, b) => a.data().level - b.data().level)
            .map((data) => {
              return <PertanyaanListDiv data={data}></PertanyaanListDiv>;
            })}
        </div>

        <div className="unlisted-list">
          {unlistedList.map((data) => {
            return <UnlistedListDiv data={data}></UnlistedListDiv>;
          })}
        </div>

        <div className="tambah-pertanyaan-overlay non-display">
          <div className="tambah-pertanyaan-overlay-content">
            <div
              className="tambah-pertanyaan-close"
              onClick={CloseTambahPertanyaanOverlay}
            ></div>
            <div className="tambah-pertanyaan-overlay-content-title">
              <h1>Tambah Pertanyaan</h1>
            </div>

            <form className="tambah-pertanyaan-form">
              <div className="tambah-pertanyaan-form-item">
                <div className="tambah-pertanyaan-form-item-pertanyaan">
                  <label>Pertanyaan</label>
                  <input
                    type="text"
                    name="pertanyaan"
                    value={PertanyaanTambah}
                    onChange={(e) => {
                      setPertanyaanTambah(e.target.value);
                    }}
                  />
                </div>

                <div className="tambah-pertanyaan-form-item-jawabanA">
                  <label>Jawaban A</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionATambah}
                    onChange={(e) => {
                      setOptionATambah(e.target.value);
                    }}
                  />
                </div>

                <div className="tambah-pertanyaan-form-item-jawabanB">
                  <label>Jawaban B</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionBTambah}
                    onChange={(e) => {
                      setOptionBTambah(e.target.value);
                    }}
                  />
                </div>

                <div className="tambah-pertanyaan-form-item-jawabanC">
                  <label>Jawaban C</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionCTambah}
                    onChange={(e) => {
                      setOptionCTambah(e.target.value);
                    }}
                  />
                </div>

                <div className="tambah-pertanyaan-form-item-jawabanD">
                  <label>Jawaban D</label>
                  <input
                    type="text"
                    name="jawaban"
                    value={OptionDTambah}
                    onChange={(e) => {
                      setOptionDTambah(e.target.value);
                    }}
                  />
                </div>

                <div className="edit-pertanyaan-form-item-jawabanBenar">
                  <label>Jawaban Benar</label>
                  <select
                    name="jawaban"
                    value={JawabanTambah}
                    onChange={(e) => {
                      setJawabanTambah(e.target.value);
                    }}
                  >
                    <option value="">--Please choose an option--</option>
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                    <option value="D">D</option>
                  </select>
                </div>

                <div className="tambah-pertanyaan-form-item-level">
                  <label>Level</label>
                  <input
                    type="number"
                    name="level"
                    value={LevelTambah}
                    onChange={(e) => {
                      setLevelTambah(e.target.value);
                    }}
                  />
                </div>

                <div className="tambah-pertanyaan-form-item-nomor">
                  <label>Nomor</label>
                  <input
                    type="number"
                    name="nomor"
                    value={NomorTambah}
                    onChange={(e) => {
                      setNomorTambah(e.target.value);
                    }}
                  />
                </div>
              </div>
            </form>

            <div className="tambah-pertanyaan-overlay-content-btn">
              <div
                className="tambah-pertanyaan-overlay-content-btn-save"
                onClick={TambahPertanyaanSaveButton}
              >
                Tambah Pertanyaan
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
